var map = {
	"./back.inline.svg": 207,
	"./cristianguerra.inline.svg": 197,
	"./css3.inline.svg": 208,
	"./docker.inline.svg": 209,
	"./gatsby.inline.svg": 210,
	"./git.inline.svg": 211,
	"./github.inline.svg": 212,
	"./gitlab.inline.svg": 213,
	"./graphql.inline.svg": 214,
	"./grunt.inline.svg": 215,
	"./gulp.inline.svg": 216,
	"./html5.inline.svg": 217,
	"./js.inline.svg": 218,
	"./linux.inline.svg": 219,
	"./logo.inline.svg": 198,
	"./mountains.inline.svg": 199,
	"./mysql.inline.svg": 220,
	"./netlify.inline.svg": 221,
	"./node.inline.svg": 222,
	"./notfound.inline.svg": 200,
	"./npm.inline.svg": 223,
	"./php.inline.svg": 224,
	"./react.inline.svg": 225,
	"./rocket-icon.inline.svg": 226,
	"./rocket.inline.svg": 201,
	"./sass.inline.svg": 227,
	"./sketch-logo.inline.svg": 228,
	"./sketch.inline.svg": 229,
	"./webpack.inline.svg": 230,
	"./wordpress.inline.svg": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;